import { FunctionComponent } from "react";

export const IconButtonHitArea: FunctionComponent = () => (
    <div style={{
        width: 120,
        height: 120,
        position: "absolute",
        zIndex: 1,
    }} />
);
